<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.code ? activeProduct.code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Product name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.name ? activeProduct.name : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Family" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.product_brand ? activeProduct.product_brand : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                <span
                    v-if="activeProduct.status"
                    class="dot"
                    :style="{ 'background-color': getStatusColor(activeProduct.status) }"
                />{{
                    activeProduct.status
                        ? t(activeProduct.status.charAt(0).toUpperCase() + activeProduct.status.slice(1))
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col class="col-item" cols="6"
                >{{
                    activeProduct.product_type
                        ? t(
                              activeProduct.product_type.charAt(0).toUpperCase() +
                                  activeProduct.product_type.replace("_", " ").slice(1)
                          )
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct.odoo_code">
            <v-col class="col-item row-title" cols="3">{{ `ODOO ${t("Code").toLowerCase()}` }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.odoo_code ? activeProduct.odoo_code : "-" }}
            </v-col>
        </v-row>
        <v-divider class="my-2" />
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Accounting class" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.accounting_class ? activeProduct.data.accounting_class : "-" }}
            </v-col>
        </v-row>
        <v-row class="align-center">
            <v-col class="col-item row-title" cols="3">
                {{ "Price list price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "Price list price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.list_net_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.list_net_price)">
                    ({{ pricePerKg(activeProduct.list_net_price) }} €/kg)
                </span>
                <v-icon
                    v-if="
                        activeProduct.list_net_price &&
                        hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.VIEW)
                    "
                    @click="openPriceModal('list_net_price')"
                    small
                >
                    fas fa-eye
                </v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">
                {{ "Cost price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "Cost price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.cost_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.cost_price)">
                    ({{ pricePerKg(activeProduct.cost_price) }} €/kg)
                </span>
                <v-icon
                    v-if="
                        activeProduct.cost_price &&
                        hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.VIEW)
                    "
                    @click="openPriceModal('cost_price')"
                    small
                >
                    fas fa-eye
                </v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">
                {{ "Own price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "Own price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.own_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.own_price)">
                    ({{ pricePerKg(activeProduct.own_price) }} €/kg)
                </span>
                <v-icon
                    v-if="
                        activeProduct.own_price &&
                        hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.VIEW)
                    "
                    @click="openPriceModal('own_price')"
                    small
                >
                    fas fa-eye
                </v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">
                {{ "E-shop price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "E-shop price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.e_shop_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.e_shop_price)">
                    ({{ pricePerKg(activeProduct.e_shop_price) }} €/kg)
                </span>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">
                {{ "Export price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "Export price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.export_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.export_price)">
                    ({{ pricePerKg(activeProduct.export_price) }} €/kg)
                </span>
                <v-icon
                    v-if="
                        activeProduct.export_price &&
                        hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.VIEW)
                    "
                    @click="openPriceModal('export_price')"
                    class="mr-1"
                    small
                >
                    fas fa-eye
                </v-icon>
                <v-icon
                    x-small
                    v-if="
                        activeProduct.export_price &&
                        hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.VIEW)
                    "
                    @click="handleExportPriceSyncClick"
                    >fas fa-sync
                </v-icon>
            </v-col>
        </v-row>

        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Market" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.market ? activeProduct.data.market : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Product name (eng)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.name_en ? activeProduct.data.name_en : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">
                {{ "Base Net price" | t }}
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class=" info-icon"> info</v-icon>
                    </template>
                    <span>{{ "Base Net price" | t }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.base_net_price | rn }}
                <span class="pr-1 kilogram-price-span" v-if="pricePerKg(activeProduct.data.base_net_price)">
                    ({{ pricePerKg(activeProduct.data.base_net_price) }} €/kg)
                </span>
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Preservation conditions (min)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.preservation_conditions_min | rn }}
                <span v-if="activeProduct.data.preservation_conditions_min"> ℃</span>
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Preservation conditions (max)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.data.preservation_conditions_max | rn
                }}<span v-if="activeProduct.data.preservation_conditions_max"> ℃</span></v-col
            >
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Category" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.product_category ? activeProduct.product_category : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "ODOO Category" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.odoo_category ? activeProduct.odoo_category : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Storage life (months)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.storage_life ? activeProduct.storage_life : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeProduct && activeProduct.data">
            <v-col class="col-item row-title" cols="3">{{ "Storage conditions" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.storage_conditions ? activeProduct.storage_conditions : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col class="col-item" cols="6"> {{ activeProduct.comment ? activeProduct.comment : "-" }}</v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Launched date" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.launched_date ? activeProduct.launched_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Finished date" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.finished_date ? activeProduct.finished_date : "-" }}
            </v-col>
        </v-row>

        <v-divider class="my-2" />
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Unit" | t }}</v-col>
            <v-col class="col-item" cols="6"> {{ activeProduct.unit ? this.t(activeProduct.unit) : "-" }}</v-col>
        </v-row>
        <div v-if="activeProduct.turnover_shops && activeProduct.turnover_shops.length > 0">
            <v-divider class="my-2" />
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Turnover" | t }}</v-col>
                <v-col class="col-item" cols="6"> {{ activeProduct.turnover | rn }}€</v-col>
            </v-row>
        </div>
        <v-divider class="my-2" />

        <v-img
            v-if="activeProduct.image && activeProduct.image_path"
            :src="activeProduct.image_path"
            max-width="350"
            contain
            class="grey lighten-2"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../../../store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "general-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        },
        ...mapState("ProductStore", ["activeProduct"]),
    },
    methods: {
        ...mapMutations("ProductStore", ["setPriceModal", "setPriceModalType"]),
        ...mapActions("ExportSaleInvoiceStore", ["updateSalesInvoicesRowsExportPriceProperty"]),
        getStatusColor(status) {
            if (status === "active") {
                return "#4CAF50";
            } else if (status === "in development") {
                return "#FB8C00";
            } else if (status === "special order") {
                return "#005DFF";
            } else if (status === "private label") {
                return "#FF0051";
            } else {
                return "#999999";
            }
        },
        async handleExportPriceSyncClick() {
            Store.commit("ProductStore/setRequestSuccess", false);
            Store.commit("ProductStore/setRequestError", false);
            if (confirm("Are you sure you want to update all export sales invoices rows?")) {
                let response = await this.updateSalesInvoicesRowsExportPriceProperty(this.activeProduct.id);
                if (response && response.data.success === 1) {
                    Store.commit("ProductStore/setRequestSuccess", true);
                } else {
                    Store.commit("ProductStore/setRequestError", true);
                }
            }
        },
        async openPriceModal(priceType) {
            await this.setPriceModalType(priceType);
            await this.setPriceModal(true);
        },
        pricePerKg(price) {
            const weightGrams = parseFloat(this.activeProduct.neto_weight) || 0;
            if (!weightGrams) return null;
            const weightKg = weightGrams / 1000;
            const priceValue = parseFloat(price) || 0;
            return weightKg && priceValue ? (priceValue / weightKg).toFixed(2) : null;
        },
    },
};
</script>

<style scoped>
.info-icon {
    font-size: 18px;
}
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.kilogram-price-span {
    color: gray;
}
</style>
